import type { Bounds } from "./bounds";

export const BOARD_DEBUG_PAD_PX = 4;

/** Site/part chips: outer box-shadow bleed past getBoundingClientRect. */
export const LOCATION_CHIP_DEBUG_PAD_PX = BOARD_DEBUG_PAD_PX + 5;

function worldScale(world: HTMLElement): number {
  if (world.offsetWidth <= 0) {
    return 1;
  }
  return world.getBoundingClientRect().width / world.offsetWidth;
}

export function elementBoundsInWorld(
  world: HTMLElement,
  el: HTMLElement,
): Bounds {
  const origin = world.getBoundingClientRect();
  const rect = el.getBoundingClientRect();
  const inv = 1 / worldScale(world);
  return {
    minX: (rect.left - origin.left) * inv,
    minY: (rect.top - origin.top) * inv,
    maxX: (rect.right - origin.left) * inv,
    maxY: (rect.bottom - origin.top) * inv,
  };
}

export function padBounds(box: Bounds, pad: number): Bounds {
  return {
    minX: box.minX - pad,
    minY: box.minY - pad,
    maxX: box.maxX + pad,
    maxY: box.maxY + pad,
  };
}
